<template>
  <div>
    <navi-modal
      v-if="naviFlag"
      @close="naviFlag = !naviFlag"
      :addrName="obituaryDetail && obituaryDetail.addrName"
      :addr-x="obituaryDetail && obituaryDetail.addrX"
      :addr-y="obituaryDetail && obituaryDetail.addrY"
    />

    <traffic-modal
      v-if="trafficFlag"
      :trafficType="trafficType"
      :address="obituaryDetail.Address"
      @close="trafficFlag = !trafficFlag"
    />
    <div class="obituary-map__wrap">
      <div><h4 class="map__title">오시는 길</h4></div>
      <div
        v-if="
          !obituaryDetail ||
            (obituaryDetail && !obituaryDetail.addrX && !obituaryDetail.addrY)
        "
      >
        <h4 class="disable__text">
          지도를 표시할 수 없습니다
        </h4>
      </div>
      <ka-kao-map
        v-else
        :addr-x="obituaryDetail && obituaryDetail.addrX"
        :addr-y="obituaryDetail && obituaryDetail.addrY"
      />

      <div class="map-info">
        <ul>
          <li @click="requestTrafficModal('bus')">
            <span>교통안내</span>
          </li>
          <li @click="requestTrafficModal('parking')">
            <span>주차안내</span>
          </li>
          <li @click="requestNaviModal">
            <span>길 찾기</span>
          </li>
        </ul>
      </div>

      <div class="address-call">
        <div>
          <div class="call__wrap">
            <h5>{{ obituaryDetail && obituaryDetail.addrName }}</h5>
            <a :href="`tel:${obituaryDetail && obituaryDetail.callNumber}`">
              <img src="@/assets/icons/obituary/phone.svg" alt="phoneIcon" />
            </a>
          </div>
          <p>{{ obituaryDetail && obituaryDetail.addr }}</p>
        </div>
        <button @click="copyAddr(obituaryDetail.addr)">
          주소복사
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import KaKaoMap from "../KaKaoMap.vue";
import NaviModal from "../NaviModal.vue";
import TrafficModal from "../TrafficModal.vue";
export default {
  components: { NaviModal, KaKaoMap, TrafficModal },
  name: "ObituaryNaviInfo",
  props: ["obituaryDetail"],

  data() {
    return {
      naviFlag: false,
      trafficFlag: false,
      trafficType: "bus"
    };
  },
  methods: {
    requestNaviModal() {
      this.naviFlag = !this.naviFlag;
    },
    requestTrafficModal(trafficType) {
      this.trafficType = trafficType;
      this.trafficFlag = true;
    },
    copyAddr(addr) {
      if (!document.queryCommandSupported("copy")) {
        return alert("복사하기가 지원되지 않는 브라우저입니다.");
      }

      const textarea = document.createElement("textarea");
      textarea.value = addr;
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.position = "fixed";

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("클립보드에 복사되었습니다.");
    }
  }
};
</script>

<style></style>
